export const IBAN_IT = 'IT73Q0200809440000107046786';
export const IBAN_ES = 'ES9401490101110306801001';
export const IBAN_DE = 'DE63700202700667522161';

export const PAYEE_DE = 'SevenOneMedia GmbH';
export const BANK_DE = 'UniCredit Bank AG Munich';
